import React from 'react';
import Icon from '../Icon';
import { useSiteContent } from '../SiteContent';
import SuchmaschinenHinweis from '../../components/SuchmaschinenHinweis';

/**
 * Schalter für den Bearbeiten-Modus, unten am Bildschirmrand.
 *
 * Erscheint ausschließlich für angemeldete Administratoren — für alle anderen
 * gibt die Komponente nichts aus, es gibt also auch nichts zu verbergen.
 */
const EditBar: React.FC = () => {
  const { canEdit, editing, setEditing, changedCount } = useSiteContent();

  if (!canEdit) return null;

  return (
    <div className={`site-editbar${editing ? ' site-editbar--on' : ''}`}>
      <button type="button" className="site-editbar__toggle" onClick={() => setEditing(!editing)}>
        <Icon name="pencil" size={15} />
        {editing ? 'Bearbeiten beenden' : 'Texte bearbeiten'}
      </button>
      {editing && (
        <span className="site-editbar__info">
          {changedCount === 0
            ? 'Auf Stift klicken, um einen Text zu ändern'
            : `${changedCount} ${changedCount === 1 ? 'Text weicht' : 'Texte weichen'} vom Original ab`}
        </span>
      )}
      {editing && <SuchmaschinenHinweis className="site-editbar__hinweis" />}
    </div>
  );
};

export default EditBar;
